<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path
            d="M7.21777 20.7795C6.43055 21.5677 5.08331 21.0102 5.08331 19.8962V14.8958H10.0884C11.2017 14.8958 11.7596 16.2417 10.9727 17.0293L9.418 18.5854C10.6898 19.886 12.4309 20.6209 14.25 20.625C17.1598 20.6207 19.7517 18.7851 20.7216 16.0417H20.7423C20.8735 15.6688 20.9728 15.2855 21.039 14.8958H23.3445C22.767 19.4791 18.8694 22.9165 14.25 22.9167H14.2385C11.8079 22.9239 9.47548 21.9584 7.76113 20.2354L7.21777 20.7795ZM7.45977 12.6042H5.15435C5.73157 8.02269 9.62654 4.5858 14.2443 4.5833H14.25C16.681 4.57552 19.014 5.54108 20.7285 7.2646L21.2839 6.71064C22.0718 5.92473 23.4166 6.48278 23.4166 7.59565V12.6042H18.4149C17.3011 12.6042 16.7435 11.2574 17.5313 10.47L19.0877 8.9146C17.8145 7.61252 16.071 6.87746 14.25 6.87501C11.3402 6.87931 8.74824 8.71497 7.77831 11.4583H7.75769C7.62541 11.8309 7.52496 12.2143 7.45977 12.6042Z"
            fill="#7A7A7A" />
    </svg>
</template>

<script>
export default {
    name: 'RefreshIconDisabled'
}
</script>